module.exports = __webpack_public_path__ + "static/img/1_0008.14dfb73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0008.jpg
// module id = 4f6u
// module chunks = 0